import { HttpRequest, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { HttpErrorHandler, Priority, HttpResponseStatus } from "@spartacus/core";

@Injectable({
  providedIn: 'root'
})
export class UnauthorizedServiceService extends HttpErrorHandler {

  getPriority?(): Priority;

  responseStatus = HttpResponseStatus.FORBIDDEN;

  handleError(request: HttpRequest<any>, errorResponse: HttpErrorResponse) {
    if (errorResponse.error.hasOwnProperty('errors')) {  
      // this.globalMessageService.add(
      //   errorResponse.error.errors[0].message,
      //   GlobalMessageType.MSG_TYPE_ERROR
      // );
    } 
  }
}

